module.exports = __webpack_public_path__ + "static/media/personalProject.ae2adc95.jpg";